<template>
    <p
      v-if="bibl"
    >
      {{ $t('In:') }} {{ bibl['#text'] }}
    </p>
</template>

<script>
export default {

  name: 'CmifCorrespSource',

  props: {
    bibl: { type: Object, default: null }
  }
}
</script>

<style lang="css" scoped>
.v-list-item__subtitle {
  white-space: normal;
}
</style>
